import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getStations } from '../../../api/stations';
import { IUseStationParameters } from '../../../ts/interface/station.interface';

const useStation = (
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>,
  parameters?: IUseStationParameters
) => {
  return useQuery({
    queryKey: ['stations', parameters],
    queryFn: () => getStations(parameters),
    ...options,
  });
};

export default useStation;
